// extracted by mini-css-extract-plugin
module.exports = {"sectionRowGrid":"style_sectionRowGrid__IdWi7","title":"style_title__AIjyn","sectionRowGridWrapper":"style_sectionRowGridWrapper__lJcC9"};